import { getItemFromCollection } from "directus/src/operations";

export async function fetchContractData({ contractId }) {
  try {
    const query = {
      fields: [
        "id",
        "name",
        "status",
        "type",
        "project"
      ],
    };
    const response = await getItemFromCollection("contracts", contractId, query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
